import React from 'react';

import Confirm from 'components/shared/Modal/Confirm/Confirm';

import EnrollmentModal from '../../EnrollmentModal/EnrollmentModal';

const StaffModals = ({
  enrollModalOpen,
  unenrollConfirmOpen,
  selectedProvider,
  selectedRows,
  practiceId,
  isAdmin,
  onCloseEnrollModal,
  onCloseUnenrollConfirm,
  onEnrollSuccess,
  onUnenrollConfirm,
  isUnenrollLoading
}) => {
  const provider = selectedProvider || selectedRows[0];

  return (
    <>
      <EnrollmentModal
        isOpen={enrollModalOpen}
        handleClose={onCloseEnrollModal}
        provider={provider}
        practiceId={practiceId}
        onEnrollSuccess={onEnrollSuccess}
        isAdmin={isAdmin}
      />
      <Confirm
        title="Confirm Un-enroll"
        isOpen={unenrollConfirmOpen}
        handleClose={onCloseUnenrollConfirm}
        variant="danger"
        footerActions={{
          primary: {
            disabled: isUnenrollLoading,
            text: 'Un-enroll',
            onClick: onUnenrollConfirm
          }
        }}
        message={`Are you sure you want to un-enroll ${provider?.f_name || ''} ${provider?.l_name || ''}? This will revoke their e-prescribing permissions.`}
        loading={isUnenrollLoading}
      />
    </>
  );
};

export default StaffModals;
